import { APP_INITIALIZER, Injector } from '@angular/core';

import { DeferredStarterService } from '../services/deferred-starter.service';
import { PageVisibilityRefreshService } from '../services/page-visibility-refresh.service';

/**
 * Inicializa o listener de Page Visibility após o navegador estar ocioso,
 * sem acoplar ao AppComponent nem ao caminho crítico do primeiro paint.
 */
export function initializePageVisibilityRefresh(deferredStarter: DeferredStarterService, injector: Injector): () => void {
  return () => {
    deferredStarter.runWhenIdle(() => {
      injector.get(PageVisibilityRefreshService);
    });
  };
}

export const providePageVisibilityRefresh = () => ({
  provide: APP_INITIALIZER,
  useFactory: initializePageVisibilityRefresh,
  deps: [DeferredStarterService, Injector],
  multi: true,
});
